import {
    AxiosInstance,
    AxiosResponse,
    InternalAxiosRequestConfig,
} from 'axios';
import { camelizeKeys, decamelizeKeys } from 'humps';

const camelizeResponse = (response: AxiosResponse) => {
    if (
        response.data &&
        response.headers['content-type'].includes('application/json')
    ) {
        response.data = camelizeKeys(response.data);
    }
    return response;
};

const decamelizeRequest = (config: InternalAxiosRequestConfig) => {
    const newConfig = { ...config };

    if (
        newConfig.headers &&
        newConfig.headers['Content-Type'] === 'multipart/form-data'
    ) {
        return newConfig;
    }

    if (config.params) {
        newConfig.params = decamelizeKeys(config.params);
    }

    if (config.data) {
        newConfig.data = decamelizeKeys(config.data);
    }

    return newConfig;
};

const addCaseInterceptor = (axiosInstance: AxiosInstance) => {
    axiosInstance.interceptors.response.use(camelizeResponse);
    axiosInstance.interceptors.request.use(decamelizeRequest);
};

export { camelizeResponse, decamelizeRequest, addCaseInterceptor };
